/**
 * Datos de testimonios de clientes
 */

export const TESTIMONIALS = [
  {
    id: 1,
    name: "María González",
    role: "Hija de paciente",
    content: "La atención de Geriatría Serena ha sido excepcional. Mi mamá recibió cuidados de alta calidad y el personal siempre fue amable y profesional.",
    rating: 5
  },
  {
    id: 2,
    name: "Javier Rodríguez",
    role: "Familia de paciente",
    content: "Contratamos los servicios de enfermería a domicilio y quedamos muy satisfechos. Puntuales, responsables y con un trato humano excelente.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Martínez",
    role: "Paciente",
    content: "Como adulta mayor viviendo sola, el servicio de cuidadoras ha sido invaluable para mi bienestar y seguridad. ¡Altamente recomendable!",
    rating: 5
  }
];
